import React from 'react';

const Copyright = () => (
  <div className="px-xl-0 px-3">
    <p className="text__fs-10">© Out of the Ark Ltd</p>
  </div>
);

export default Copyright;
